module.exports = __webpack_public_path__ + "static/media/3.3fcb246a.png";